var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.drawer,
            size: "90%",
            wrapperClosable: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "form-center",
            },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    "label-width": "130px",
                    rules: _vm.rules,
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "处置单号", prop: "ScrapCode" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: _vm.disabled,
                                  placeholder: "请输入处置单号",
                                },
                                model: {
                                  value: _vm.form.ScrapCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "ScrapCode", $$v)
                                  },
                                  expression: "form.ScrapCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "处置日期", prop: "ScrapDate" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: _vm.disabled,
                                  "value-format": "yyyy-MM-dd",
                                  type: "date",
                                  placeholder: "请选择日期",
                                },
                                model: {
                                  value: _vm.form.ScrapDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "ScrapDate", $$v)
                                  },
                                  expression: "form.ScrapDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "处置类型", prop: "ScrapType" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.disabled,
                                    placeholder: "请选择",
                                    clearable: "",
                                    filterable: "",
                                  },
                                  model: {
                                    value: _vm.form.ScrapType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "ScrapType", $$v)
                                    },
                                    expression: "form.ScrapType",
                                  },
                                },
                                _vm._l(_vm.ScrapTypeList, function (item) {
                                  return _c("el-option", {
                                    key: item.Value,
                                    attrs: {
                                      label: item.Name,
                                      value: item.Value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "资产编号", prop: "AssetCode" } },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    width: "100%",
                                    display: "flex",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "calc(100% - 60px)" },
                                    attrs: {
                                      placeholder: "请选择资产",
                                      disabled: "",
                                    },
                                    model: {
                                      value: _vm.form.AssetCode,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "AssetCode", $$v)
                                      },
                                      expression: "form.AssetCode",
                                    },
                                  }),
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { width: "60px" },
                                      attrs: {
                                        disabled: _vm.disabled,
                                        type: "primary",
                                      },
                                      on: { click: _vm.openAsset },
                                    },
                                    [_c("i", { staticClass: "el-icon-search" })]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "资产名称", prop: "AssetName" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: "",
                                  placeholder: "请输入资产名称",
                                },
                                model: {
                                  value: _vm.form.AssetName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "AssetName", $$v)
                                  },
                                  expression: "form.AssetName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "原值", prop: "OriginalValue" } },
                            [
                              _c("el-input", {
                                attrs: { disabled: "", type: "number" },
                                model: {
                                  value: _vm.form.OriginalValue,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "OriginalValue", $$v)
                                  },
                                  expression: "form.OriginalValue",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "累计折旧月",
                                prop: "AccumulatedDepreciationMonths",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "", type: "number" },
                                model: {
                                  value: _vm.form.AccumulatedDepreciationMonths,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "AccumulatedDepreciationMonths",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "form.AccumulatedDepreciationMonths",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "累计折旧",
                                prop: "AccumulatedDepreciation",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "", type: "number" },
                                model: {
                                  value: _vm.form.AccumulatedDepreciation,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "AccumulatedDepreciation",
                                      $$v
                                    )
                                  },
                                  expression: "form.AccumulatedDepreciation",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "净值", prop: "NetValue" } },
                            [
                              _c("el-input", {
                                attrs: { disabled: "", type: "number" },
                                model: {
                                  value: _vm.form.NetValue,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "NetValue", $$v)
                                  },
                                  expression: "form.NetValue",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "残值", prop: "NetSalvage" } },
                            [
                              _c("el-input", {
                                attrs: { disabled: "", type: "number" },
                                model: {
                                  value: _vm.form.NetSalvage,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "NetSalvage", $$v)
                                  },
                                  expression: "form.NetSalvage",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "变动值", prop: "ChangeAmount" },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: _vm.disabled,
                                  type: "number",
                                },
                                model: {
                                  value: _vm.form.ChangeAmount,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "ChangeAmount", $$v)
                                  },
                                  expression: "form.ChangeAmount",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "评估后值",
                                prop: "EvaluationValue",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: _vm.disabled,
                                  type: "number",
                                },
                                model: {
                                  value: _vm.form.EvaluationValue,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "EvaluationValue", $$v)
                                  },
                                  expression: "form.EvaluationValue",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "处置收入",
                                prop: "NonOperatingIncome",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: _vm.disabled,
                                  type: "number",
                                },
                                model: {
                                  value: _vm.form.NonOperatingIncome,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "NonOperatingIncome",
                                      $$v
                                    )
                                  },
                                  expression: "form.NonOperatingIncome",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "清理费用",
                                prop: "CleaningUpCost",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: _vm.disabled,
                                  type: "number",
                                },
                                model: {
                                  value: _vm.form.CleaningUpCost,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "CleaningUpCost", $$v)
                                  },
                                  expression: "form.CleaningUpCost",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "处置人",
                                prop: "DisposalPerson",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: _vm.disabled,
                                  placeholder: "处置人",
                                },
                                model: {
                                  value: _vm.form.DisposalPerson,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "DisposalPerson", $$v)
                                  },
                                  expression: "form.DisposalPerson",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "是否折旧",
                                prop: "DepreciationStatus",
                              },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  attrs: { disabled: _vm.disabled },
                                  model: {
                                    value: _vm.form.DepreciationStatus,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "DepreciationStatus",
                                        $$v
                                      )
                                    },
                                    expression: "form.DepreciationStatus",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: 0 } }, [
                                    _vm._v("否"),
                                  ]),
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v("是"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 16 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "备注", prop: "Remark" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "",
                                  disabled: _vm.disabled,
                                  type: "textarea",
                                  rows: "3",
                                  resize: "none",
                                },
                                model: {
                                  value: _vm.form.Remark,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "Remark", $$v)
                                  },
                                  expression: "form.Remark",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "附件", prop: "ProjectImg" } },
                            [
                              _c(
                                "el-upload",
                                {
                                  staticClass: "avatar-uploader",
                                  attrs: {
                                    disabled: _vm.disabled,
                                    action:
                                      _vm.$rootUrl +
                                      `/Base_Manage/Upload/ProjectOssUploadFileByForm?Type=5`,
                                    headers: {
                                      Authorization: _vm.token,
                                    },
                                    "show-file-list": false,
                                    "on-success": _vm.handleAvatarSuccess,
                                    "before-upload": _vm.beforeAvatarUpload,
                                  },
                                },
                                [
                                  _vm.form.AttachmentUrl
                                    ? _c("el-image", {
                                        staticClass: "projectImg",
                                        attrs: {
                                          fit: "contain",
                                          src: _vm.form.AttachmentUrl,
                                        },
                                      })
                                    : _c("i", {
                                        staticClass:
                                          "el-icon-plus avatar-uploader-icon",
                                      }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
              !_vm.disabled
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmit(0)
                        },
                      },
                    },
                    [_vm._v("保存")]
                  )
                : _vm._e(),
              !_vm.disabled
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmit(1)
                        },
                      },
                    },
                    [_vm._v("提交")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c("AssetDialog", {
        ref: "AssetDialog",
        attrs: { type: "radio" },
        on: { select: _vm.handleAssetSelect },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }